import { render, staticRenderFns } from "./FolderRelaunchEmailLogDialog.vue?vue&type=template&id=8509ba22&scoped=true"
import script from "./FolderRelaunchEmailLogDialog.vue?vue&type=script&lang=js"
export * from "./FolderRelaunchEmailLogDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderRelaunchEmailLogDialog.vue?vue&type=style&index=0&id=8509ba22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8509ba22",
  null
  
)

export default component.exports